var $f8689dc93e68c942$exports = {};
$f8689dc93e68c942$exports = {
    "replaceMessage": `Otpustite datoteku radi zamene`
};


export {$f8689dc93e68c942$exports as default};
//# sourceMappingURL=sr-SP.mjs.map
